"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveQuantity = void 0;
const TDR_1 = require("../types/TDR");
const resolveQuantity = (qty, groupSize, defaultValue) => {
    if (qty === TDR_1.TDR.Ecommerce.QuantityMode.GROUP_SIZE) {
        return groupSize;
    }
    if (typeof qty === 'number') {
        return qty;
    }
    return defaultValue;
};
exports.resolveQuantity = resolveQuantity;
//# sourceMappingURL=resolveQuantity.js.map